"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.validationErrorMap = exports.RestApiValidationErrorCode = void 0;
var RestApiValidationErrorCode;
(function (RestApiValidationErrorCode) {
    RestApiValidationErrorCode["InvalidApiName"] = "InvalidApiName";
    RestApiValidationErrorCode["InvalidPath"] = "InvalidPath";
})(RestApiValidationErrorCode || (exports.RestApiValidationErrorCode = RestApiValidationErrorCode = {}));
exports.validationErrorMap = {
    [RestApiValidationErrorCode.InvalidApiName]: {
        message: 'API name is invalid.',
        recoverySuggestion: 'Check if the API name matches the one in your configuration or `aws-exports.js`',
    },
    [RestApiValidationErrorCode.InvalidPath]: {
        message: 'API path does not resolve to the same protocol, host and userinfo as the configured endpoint.',
        recoverySuggestion: 'Make sure the path is relative to the configured endpoint (for example `/items`) and does not change its host, port, or protocol.',
    },
};
